module.exports = __webpack_public_path__ + "img/img02.66baafd5.png";